import { createSelector } from "@reduxjs/toolkit";
import { cancelQuoteSlice } from "./cancelQuoteSlice";
import { slice } from "./slice";

export const selectSliceState = (
  state: Parameters<typeof slice.selectSlice>[0]
) => {
  if (!(slice.reducerPath in state)) {
    console.warn(
      `The slice reducer path "${slice.reducerPath}" was not found in the state. falling back to initial state.`
    );
    return slice.getInitialState();
  }

  return slice.selectSlice(state);
};

export const selectQuoteFetchState = createSelector(
  selectSliceState,
  ({ quoteFetchState }) => quoteFetchState
);

export const selectSuccessQuoteFetchState = createSelector(
  selectQuoteFetchState,
  ({ data }) =>
    data?.AirCfarExerciseQuoteResponse === "QuoteSuccess" ? data : undefined
);

export const selectQuoteFetchTrackingProperties = createSelector(
  selectSuccessQuoteFetchState,
  (state) => state?.trackingProperties
);

export const selectFulfillQuoteFetchState = createSelector(
  selectSliceState,
  ({ fulfillQuoteFetchState }) => fulfillQuoteFetchState
);

export const selectCancelQuoteSliceState = (
  state: Parameters<typeof cancelQuoteSlice.selectSlice>[0]
) => {
  if (!(cancelQuoteSlice.reducerPath in state)) {
    console.warn(
      `The slice reducer path "${cancelQuoteSlice.reducerPath}" was not found in the state.`
    );
    return cancelQuoteSlice.getInitialState();
  }
  return cancelQuoteSlice.selectSlice(state);
};

export const selectCancelQuoteFetchState = createSelector(
  selectCancelQuoteSliceState,
  ({ cancelQuoteFetchState }) => cancelQuoteFetchState
);
